// @ts-strict

import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ISingleCampaign, SpecialCampaignData } from '@app/core/models/core-models';
import { UrlAddressConfigService } from '@services/url-address-config/url-address-config.service';
import { ProgramConfiguration } from '@services/url-address-config/url-address-config.types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SingleCampaignModalComponent } from '../single-campaign-modal.component';

@Component({
  selector: 'app-configuration-selection',
  templateUrl: './configuration-selection.component.html',
  styleUrls: ['./configuration-selection.component.scss']
})
export class ConfigurationSelectionComponent implements OnInit {
  @Input() currentCampaign?: ISingleCampaign | SpecialCampaignData;
  @Input() submitted: boolean = false;
  @Output() emitConfig: EventEmitter<ProgramConfiguration> = new EventEmitter();

  public urlConfigs: ProgramConfiguration[] = [];
  public configurationSelect = this.fb.group({
    selectedConfiguration: [null, Validators.required]
  });

  constructor(private fb: UntypedFormBuilder, private configService: UrlAddressConfigService, private modalService: NgbModal) {}

  ngOnInit(): void {
    this.configService.getAllConfigs(this.currentCampaign?.id || 0).subscribe(res => {
      this.urlConfigs = res.data?.program_configurations || [];
      this.selectFirstConfiguration();
    });
    this.configService.addedEditedConfig.subscribe(config => {
      this.urlConfigs = [...this.urlConfigs, config];
    });
  }

  public getData(element: ProgramConfiguration): void {
    this.emitConfig.emit(element);
  }

  public changeChevronUp(): void {
    document.getElementsByClassName('ng-arrow-wrapper')?.item(0)?.classList.add('ng-select-open');
  }

  public changeChevronDown(): void {
    document.getElementsByClassName('ng-arrow-wrapper')?.item(0)?.classList.remove('ng-select-open');
  }

  public open(modalDescription: string, modalTitle: string, modalType: string): void {
    const modalRef = this.modalService.open(SingleCampaignModalComponent, {
      size: 'me'
    });

    const componentInstance = modalRef.componentInstance as SingleCampaignModalComponent;

    componentInstance.campaignData = this.currentCampaign;
    componentInstance.modalDescriptionName = modalDescription;
    componentInstance.modalTitle = modalTitle;
    componentInstance.modalType = modalType;
    componentInstance.shortVersionWithoutSecondStep = true;
  }

  private selectFirstConfiguration(): void {
    if (this.urlConfigs.length) {
      this.configurationSelect.get('selectedConfiguration')?.patchValue(this.urlConfigs[0].id);
      this.getData(this.urlConfigs[0]);
    }
  }
}
